import StartEndDateTime from '~/components/forms/StartEndDateTime';
import { formatDateTimeLong } from '~/lib/DateTime';
import { clientFormatDateTimeLong } from '~/public/lib/ClientDateTime.js';

const WaitlistHistoryEntry = ({ entry, idx }) => {
    const clientTz = entry.settings?.timezone;

    return (
        <div className={`py-3 ${idx > 0 ? 'border-t' : ''}`}>
            {entry.event_type.name}
            <div className="text-sm text-gray-500">
                {entry.is_range && (
                    <div className="flex items-center">
                        <span className="mr-1">Any opening from </span>
                        <StartEndDateTime
                            start={entry.start}
                            end={entry.end}
                            clientTz={clientTz}
                        />
                    </div>
                )}
                {!entry.is_range &&
                    clientFormatDateTimeLong(entry.start, clientTz)}
            </div>
        </div>
    );
};

const WaitlistHistory = ({ waitlist }) => {
    return (
        <div>
            <div className="panel-label">Waitlist</div>
            <div className="panel pl-4">
                {waitlist.map((entry, idx) => (
                    <WaitlistHistoryEntry entry={entry} idx={idx} />
                ))}
            </div>
        </div>
    );
};

export default WaitlistHistory;
